import { Lock } from "lucide-react"

interface ComingSoonOverlayProps {
  message?: string
  className?: string
}

export function ComingSoonOverlay({ 
  message = "Coming Soon", 
  className = "" 
}: ComingSoonOverlayProps) {
  return (
    <div className={`absolute inset-0 z-50 backdrop-blur-[2px] ${className}`}>
      <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-background/50">
        <div className="rounded-full bg-muted p-3">
          <Lock className="h-6 w-6 text-muted-foreground" />
        </div>
        <p className="text-lg font-semibold text-muted-foreground">{message}</p>
      </div>
    </div>
  )
}
